var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "tag-dialog" } },
    [
      !_vm.inlineMode
        ? _vm._t("button", function () {
            return [
              _c(
                "div",
                { staticClass: "tag-dialog-container" },
                [
                  _vm._l(_vm.activeTags, function (tag) {
                    return _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                }",
                          },
                        ],
                        key: tag._id,
                        staticClass: "tag-dialog-element",
                        style: { "--tag-color": tag.color },
                        attrs: { content: tag.description },
                      },
                      [
                        _c("div", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                tag.name.slice(0, 15) +
                                  (tag.name.length >= 15 ? "..." : "")
                              ) +
                              "\n                "
                          ),
                        ]),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  !_vm.hideAdd
                    ? _c("a-button", {
                        staticClass: "classic-button",
                        staticStyle: {
                          "margin-left": "2px",
                          "margin-top": "1px",
                        },
                        attrs: { icon: "plus", size: "small", type: "primary" },
                        on: {
                          click: function ($event) {
                            _vm.openPopover = true
                          },
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
            ]
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.inlineMode
        ? _c("div", { staticClass: "inline-tag-dialog" }, [
            _c(
              "div",
              { staticClass: "popover-content" },
              [
                _c("a-input", {
                  attrs: { placeholder: _vm.$t("message.search") },
                  model: {
                    value: _vm.search,
                    callback: function ($$v) {
                      _vm.search = $$v
                    },
                    expression: "search",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "popover-content-labels" }, [
                  _c("h6", [_vm._v(_vm._s(_vm.$t("message.labels")))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "more-actions" },
                    _vm._l(_vm.sortedTags, function (tag) {
                      return _c(
                        "div",
                        {
                          key: tag._id,
                          staticClass: "action-button",
                          on: {
                            click: function ($event) {
                              return _vm.checkedTag(tag)
                            },
                          },
                        },
                        [
                          _c("a-checkbox", {
                            attrs: { checked: _vm.tempChecked[tag._id] },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "action-button-text",
                              style: { "--tagColor": tag.color },
                            },
                            [
                              _c("div", { staticClass: "tag-circle" }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(tag.name) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-actions" },
                  [
                    _c("a-button", { on: { click: _vm.cancelChanges } }, [
                      _vm._v("Vazgeç"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.saveChanges },
                      },
                      [_vm._v("Kaydet")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.inlineMode
        ? _c(
            "a-popover",
            {
              attrs: {
                trigger: "click",
                overlayClassName: "tag-dialog-popover",
                placement: "topLeft",
              },
              model: {
                value: _vm.openPopover,
                callback: function ($$v) {
                  _vm.openPopover = $$v
                },
                expression: "openPopover",
              },
            },
            [
              _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                _c(
                  "div",
                  { staticClass: "popover-content" },
                  [
                    _c("a-input", {
                      attrs: { placeholder: _vm.$t("message.search") },
                      model: {
                        value: _vm.search,
                        callback: function ($$v) {
                          _vm.search = $$v
                        },
                        expression: "search",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "popover-content-labels" }, [
                      _c("h6", [_vm._v(_vm._s(_vm.$t("message.labels")))]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "more-actions" },
                        _vm._l(_vm.filteredTags, function (tag) {
                          return _c(
                            "div",
                            {
                              key: tag._id,
                              staticClass: "action-button",
                              on: {
                                click: function ($event) {
                                  return _vm.checkedTag(tag)
                                },
                              },
                            },
                            [
                              _c("a-checkbox", {
                                attrs: { checked: _vm.tempChecked[tag._id] },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "action-button-text",
                                  style: { "--tagColor": tag.color },
                                },
                                [
                                  _c("div", { staticClass: "tag-circle" }),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(tag.name) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "modal-actions" },
                      [
                        _c("a-button", { on: { click: _vm.cancelChanges } }, [
                          _vm._v("Vazgeç"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.saveChanges },
                          },
                          [_vm._v("Kaydet")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }